const Constant = {
	photoMagnifier: 0.1,
	screenRatio: 1041 / 1792,
};

export default Constant;
